export default class Field {
  constructor(element, validations, toggleError) {
    this.name = element.name;
    this.error = null;
    this.touched = false;
    this.element = element;
    this.validations = validations;
    this.errorCallback = toggleError;

    if (element.type === 'checkbox') {
      element.addEventListener('change', (event) => {
        this.touched = true;
        this.checkValidation();
      });
    } else {
      element.addEventListener('blur', () => {
        this.touched = true;
        this.checkValidation();
      });

      element.addEventListener('keyup', (event) => {
        this.checkValidation();
      });
    }
  }

  getValue() {
    if (this.element.type === 'checkbox') {
      return this.element.checked;
    }

    return this.element.value;
  }

  toggleError() {
    this.errorCallback(this.element, this.error, this.touched);
    return this.error;
  }

  preSendValidation() {
    this.touched = true;
    if (this.validations[this.name]) {
      this.error = this.validations[this.name](this.getValue(), this.element);
    }
    return this.toggleError();
  }

  checkValidation() {
    if (this.validations[this.name]) {
      this.error = this.validations[this.name](this.getValue(), this.element);
    }
    return this.toggleError();
  }

  reset() {
    this.element.value = '';
    this.error = null;
    this.touched = false;

    if (this.element.type === 'checkbox') {
      this.element.checked = false;
    } else {
      this.element.value = '';
    }
  }
}
